module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"access":{"denied":"You do not have sufficient permissions to take this action"}}}')
  delete Component.options._Ctor
}
